/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PaginatedDatasetListResponse } from '../types/PaginatedDatasetList';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type DatasetsListRequest = {} | null | undefined;
export type DatasetsListResponse = PaginatedDatasetListResponse;

export type DatasetsListQuery = {
  /**
   * ```yaml
   * in: query
   * name: name__icontains
   * schema:
   *   type: string
   * ```
   */
  name__icontains?: string;

  /**
   * ```yaml
   * name: page
   * required: false
   * in: query
   * description: A page number within the paginated result set.
   * schema:
   *   type: integer
   * ```
   */
  page?: number;
};

/**
 * GET /dmx-server/datasets/
 *
 * ```yaml
 * operationId: datasets_list
 * tags:
 *   - datasets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedDatasetList'
 *     description: ''
 * ```
 */
export const datasetsListOperation = (rest?: DatasetsListQuery | null) =>
  ({
    method: 'GET',
    path: `/dmx-server/datasets/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/datasets/' };
  };

/**
 * GET /dmx-server/datasets/
 *
 * ```yaml
 * operationId: datasets_list
 * tags:
 *   - datasets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/PaginatedDatasetList'
 *     description: ''
 * ```
 */
export const datasetsList = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: DatasetsListQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<PaginatedDatasetListResponse>> => {
  const operation = datasetsListOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/datasets/
 */
export const useDatasetsListResource = (
  query: DatasetsListQuery | null,
  useCached?: boolean,
): UseResource<DatasetsListResponse> => {
  return useResource<DatasetsListResponse>({
    path: query === null ? null : datasetsListOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
